import React from "react";
import { Route, Redirect } from "react-router-dom";

const LoginComponent = ({ component: Component, token: Token, ...rest }) => {

    return (
        <Route
            {...rest}
            render={(props) =>
                Token === true ? (
                    <Redirect
                        to={{
                            pathname: "/management/properties",
                            state: { from: props.location },
                        }}
                    />
                ) : (
                    <Component {...props} />
                )
            }
        />
    );
};

export default LoginComponent;
